import { THEME_DARK } from './constants';

const currentTheme = (state) => state.currentTheme;

const isDarkTheme = (state) => state.currentTheme === THEME_DARK;

export default {
  currentTheme,
  isDarkTheme,
};
